import { GiocaBurraco } from './GiocaBurraco';
import { IconaTutorialBurraco } from './IconaTutorialBurraco';
import { TavoliMiei } from './TavoliMiei';
import { TorneiBurraco } from './TorneiBurraco';

/**
 * La Hub del Burraco (ingresso al Burraco nella TMA, PR1 di qburraco-orcb-39; condizioni Z1-Z13 di tma-orcb, schema del Bridge I-609): col gioco attivo =
 * Burraco la Hub non ha la riga delle sezioni, ha TRE blocchi — «Gioca» (Gioca, Invita un amico, Entra con un codice: le SCRITTURE, PR2), «I miei tavoli / Riprendi» e i tornei del
 * gioco — dentro UN solo scorrevole (come i pannelli dei giochi: la riga alta della chrome resta ferma).
 *
 * ⚠️ Lo monta `HubSections` SOLO dentro il confronto LETTERALE del flag (che il bundler piega): questo file e il marcatore `data-hub-burraco` non sono in
 * produzione. La serratura (`beta`, Limulo acceso) sta in `HubSections` e nel selettore.
 */
export function HubBurraco() {
  return (
    // `[touch-action:pan-y]`: la radice della Hub e' `touch-action: none` (`routes/Hub.tsx`), e senza questa riga il dito non scorrerebbe nulla — e' l'unico
    // scorrevole qui, come il contenitore dei pannelli in `HubSections`. `overscroll-contain`: un lancio a fondo corsa non trascina la Hub.
    <div data-hub-burraco className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain py-2 [touch-action:pan-y]">
      <GiocaBurraco inTitolo={<IconaTutorialBurraco />} />
      <TavoliMiei />
      <TorneiBurraco />
    </div>
  );
}
